import { EventHandlers } from '@jbhi-fi/components/src/context/Events';

export const jbEventHandlers: EventHandlers = {
  'slideout.open': data => {
    window.zE?.('webWidget', 'hide');
  },
  'slideout.close': data => {
    window.zE?.('webWidget', 'show');
  },
};
